import api from "../../services/pipelineStage";
export default function (helper) {
	/**
	 * Generated store module
	 */
	helper.setApi(api);
	const types = helper.types("pipeline_stage");
	const state = helper.state();
	const getters = helper.getters();
	const actions = helper.actions({}, "Pipeline Stage");
	const mutations = helper.mutations({}, types, state);

	return {
		namespaced: true,
		state,
		getters,
		actions,
		mutations,
	};
}
